import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
   
import { obtenerComponenteDireccionColonia } from "app/features/componentes/direccioncolonia";

export const DireccionComponent = obtenerComponenteDireccionColonia<models.Sucursal>("IdDireccionColonia", "Direccion", "Dirección");


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/sucursales/edit/direccion.tsx